




import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {CashoutData} from "../models";
import {cashoutEventBus, CashoutEvents, CheckoutErrorMode, CheckoutErrorModes} from "../bus";

@Component
export default class CashoutModalError extends Vue {
    @Prop()
    cashoutData!: CashoutData;

    mounted(): void {
        cashoutEventBus.$on(CashoutEvents.CHECKOUT_ERROR, this.checkoutError);
        cashoutEventBus.$on(CashoutEvents.CHECKOUT_FAILURE, this.checkoutFailure);
    }

    checkoutError(errorMode: CheckoutErrorMode, message: string) {
        // Handled by 2FA modal
        if (errorMode === CheckoutErrorModes.AUTH_2FA_REQUIRED || errorMode === CheckoutErrorModes.AUTH_2FA_INVALID)
            return;

        let title: string;
        let text: string;
        let buttons: any[];
        buttons = [
            {
                title: 'Close',
                default: true
            }
        ];

        switch (errorMode) {
            case CheckoutErrorModes.RATE_NO_LONGER_VALID:
                title = "Rate No Longer Valid";
                text = "The rate you were offered is no longer valid as the exchange rate has changed. " +
                    "Please check the totals again and reconfirm your order.<br><br>You have not yet been charged.";
                break;
            case CheckoutErrorModes.INSUFFICIENT_FUNDS:
                title = "Insufficient Funds";
                text = "You do not have enough funds in your wallet to cover this order. Please re-enter the " +
                    "amounts and try again.<br><br>You have not yet been charged.";
                break;
            case CheckoutErrorModes.AUTH_EXPIRED:
                title = "Login Expired";
                text = "Your Coinbase login session for this site has expired. Please login again." +
                    "<br><br>You have not yet been charged.";
                buttons = [
                    {
                        title: 'Login Again',
                        default: true,
                        handler: () => {
                            (window as any).location = '/cashout/auth';
                        },
                    },
                ];
                break;
            case CheckoutErrorModes.OVER_DAILY_LIMIT:
                title = "Over Daily Limit";
                text = "Cannot spend this amount without going over the pre-authorised daily limit. " +
                    "Please login again and raise your debit limit or alter your cashout amount." +
                    "<br><br>You have not yet been charged.";
                buttons = [
                    {
                        title: 'Change Cashout Amount',
                    },
                    {
                        title: 'Login Again',
                        default: true,
                        handler: () => {
                            (window as any).location = '/cashout/auth';
                        },
                    },
                ];
                break;
            case CheckoutErrorModes.ORDER_FAILED:
                title = "Order failed to process";
                text = "Something went wrong fulfilling your e-gift. Your cryptocurrency was withdrawn but it " +
                    "has been returned to your Coinbase wallet.<br><br>Please select a different e-gift or " +
                    "try again later.";
                break;
            default:
                title = "An unexpected error has occurred";
                text = "Please check your order and try again.<br><br>You have not been charged.";
        }

        this.$modal.show('dialog', {
            title: title,
            text: text,
            buttons: buttons,
        })
    }

    checkoutFailure() {
        this.$modal.show('dialog', {
            title: "There was a problem processing your order",
            text: "Our team has been notified of the problem and should have it fixed soon. " +
            "Please try again later.",
            buttons: [
                {
                    title: 'Close',
                    default: true
                }
            ]
        })
    }
}
